import { ApiClient } from '@api/client';

/**
 * @param params
 * @param {string} params.clerkUserId
 *
 * @returns {Promise<{
 *   current_subscription: string;
 * }>}
 */
export async function fetchCurrentSubscription({ clerkUserId }) {
  const resp = await ApiClient.get('/v2/user/current_subscription', null, {
    credentials: 'include',
    headers: {
      'X-Clerk-User-Id': clerkUserId,
    },
  });

  return await resp.json();
}
